// Library imports
import styled from 'styled-components';
import { MDBBtn } from 'mdb-react-ui-kit';

export const TabContainer = styled.div`
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 15px;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 999px;
    background: linear-gradient(135deg, #0f1117 0%, #1a1f2e 100%);
    padding: 3px;
    gap: 3px;
    width: fit-content;
    max-width: 100%;
`;

export const TabButton = styled(MDBBtn)`
    flex: 0 1 auto;
    border-radius: 999px !important;
    font-size: clamp(11px, 2.4vw, 13px);
    line-height: 1.1;
    font-weight: 700;
    padding: 0.38rem 0.9rem !important;
    min-height: 32px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    background: ${({ active }) => (active === 'true' ? 'linear-gradient(#f0c876 0%, #b47806 100%)' : 'transparent')} !important;
    color: ${({ active }) => (active === 'true' ? '#ffffff' : '#94a3b8')} !important;
    border: 1px solid ${({ active }) => (active === 'true' ? 'rgba(180,120,6,0.7)' : 'transparent')} !important;
    box-shadow: ${({ active }) => (active === 'true' ? '0 3px 10px rgba(139,94,0,0.35)' : 'none')};

    &:hover {
        background: ${({ active }) => (active === 'true' ? 'linear-gradient(#f0c876 0%, #b47806 100%)' : 'rgba(255,255,255,0.08)')} !important;
        color: #ffffff !important;
        border-color: ${({ active }) => (active === 'true' ? 'rgba(180,120,6,0.7)' : 'rgba(255,255,255,0.15)')} !important;
    }
`;
